export default "__VITE_ASSET__CyvKlD38__"